<nb-tabset (changeTab)="onChangeTab($event)">
  <nb-tab *ngIf="usersRol.CONSULTAR_MODELOS" tabTitle="Consulta" tabIcon="search-outline" responsive
    style="height: 75vh; overflow: hidden;">
    <div class="consultaTop" [hidden]="!showModelosConsulta">
      <p class="Titulo">Consulta Modelos</p>
      <button nbButton shape="round" size="small" class="buttontz float-left" style="margin-left: 10px;"
        (click)="consultarVin('Consulta')">
        <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
      </button>
      <button nbButton size="tiny" style="margin-left: 10px;" class="buttontz" [disabled]="!showModelosConsulta"
        (click)="exportToExcelModelos()">
        <nb-icon icon="save-outline"></nb-icon>Exportar
      </button>
    </div>
    <app-spinner *ngIf="!showModelosConsulta"></app-spinner>
    <div *ngIf="showModelosConsulta">
      <!-- <angular-slickgrid gridId="gridModelosConsulta" [columnDefinitions]="columnDefinitionsModelosConsulta"
        [gridOptions]="gridOptionsModelosConsulta" [dataset]="datasetModelosConsulta" gridHeight="380" gridWidth="75%"
        (onAngularGridCreated)="angularGridReadyModelosConsulta($event)">
      </angular-slickgrid> -->
      <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetModelosConsulta"
            [columnDefs]="columnDefinitionsModelosConsulta"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
    </div>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_MODELOS" tabTitle="Nuevo MODELO-VIN" tabIcon="upload-outline" responsive
    style="height: 75vh;">
    <div class="row">
      <div class="altaVinModeloContainer">
        <div class="top">
          <input type="text" placeholder="Modelo" [(ngModel)]="nombreModelo">
          <!-- <span style="background-color: yellow; height: 25px; width: 25px; border-radius: 50%;"></span> -->
          <span>* Dígitos optativos</span>
        </div>
        <!-- <p class="Titulo">Alta Codificacion</p> -->
        <div class="altaVinContainer">
          <div class="numeroDigitoContainer"> 
            <span class="numeroDigitoContainerTitle">Caracteres del VIN</span>
            <div class="numeroDigitoContainerWrapper">
              <span *ngFor="let item of codigoVin">{{item}}</span>
            </div>
          </div>
          <div class="vinsRow" *ngFor="let rows of cantidadDeVins">
            <div class="vinsRowWrapper">
              <div class="inputNumeroVINContainer">
                <div class="inputNumeroVIN" *ngFor="let item of codigoVin">
                  <!-- <span>{{item}}</span> -->
                  <input matInput type="text" maxlength="1" [disabled]="disabledInputs(item, rows)"
                    (ngModelChange)="saveDigito(item, rows, $event)" [ngModel]="vinesProcesados[rows-1][item-1]"
                    [ngStyle]="styleInputs(item)" autocomplete="off">
                  <!-- <input matInput type="text" maxlength="1" [disabled]="item === 9 || item > 11 || item === 4 || item === 8 || item === 10 ||
                    item === digAdi.d1 ||  item === digAdi.d2 || item === digAdi.d3  ? 'true':'false'"
                    (ngModelChange)="saveDigito(item, rows, $event)" [ngModel]="vinesProcesados[rows-1][item-1]"> -->
                </div>
              </div>
              <div (click)="deleteRow(rows)" class="trashContainer" *ngIf="rows != 1 && rows === cantidadDeVins.length">
                <i class="fa fa-trash" style="font-size: 20px; cursor: pointer; color: #007749;"></i>
              </div>
            </div>
          </div>
          <div class="agregarVinBTNContainer">
            <button nbButton size="tiny" status="primary" class="buttontz" (click)="agregarVin()">
              <i class="fa fa-plus" style="font-size: 10px; cursor: pointer; color: white;"></i>
            </button>
          </div>
        </div>
        <div class="altaVinModeloContainerBottom">
          <app-spinner class="float-left" *ngIf="showSpinnerGuardarVin"></app-spinner>
          <!-- <button nbButton size="tiny" status="primary" class="buttontz" *ngIf="!showSpinnerGuardarVin"
            (click)="agregarVin()">Agregar VIN</button> -->
          <button nbButton size="tiny" status="primary" class="buttontz" *ngIf="!showSpinnerGuardarVin"
            (click)="altaVin()">Guardar</button>
        </div>
      </div>
    </div>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_MODELOS" tabTitle="Modificación MODELO-VIN" tabIcon="edit-outline" responsive
    style="height: 75vh; overflow: hidden;">
    <div class="tabContainerModificacion">
      <div class="topModificacion">
        <p-dropdown required id="dropdownModificacion" placeholder="Seleccionar Modelo" [options]="modelos"
          [(ngModel)]="modeloSeleccionado" [virtualScroll]="true" [itemSize]="31" (onChange)="selectModelo()"
          [filter]="true">
        </p-dropdown>
      </div>
      <div class="bodyModificacion" *ngIf="modeloSeleccionado">

        <div class="modeloModificacion">

          <div class="modeloModificacionTop">

            <div class="reasignarModelosTitulo">
              <span>Reasignar Modelos</span>
            </div>

            <div class="digitosModificacionContainer">
              <span class="numeroDigitoContainerTitle">Caracteres del VIN</span>
              <div class="digitosModificacion">
                <span *ngFor="let item of codigoVin">
                  {{item}}
                </span>
              </div>
            </div>

          </div>

          <div class="modeloModificacionBottom">

            <div class="modeloSelectContainerBack">
              <div class="modeloSelectContainer">
                <div class="modeloSelect" *ngFor="let rows of codificacionesPorModelo, index as i">
                  <p-dropdown class="limited-selector" id="inputReasignarModelo" placeholder="{{rows.descripcion}}"
                    [options]="modelos" [(ngModel)]="reasignarModelo[i]" [virtualScroll]="true" [itemSize]="31"
                    [filter]="true" (ngModelChange)="cambioModeloCondificacion(rows,i)"
                    [disabled]="!habilitarModificarModelos">
                  </p-dropdown>
                </div>
              </div>
            </div>

            <div class="codificacionesModificacion">

              <div class="vinsRow" *ngFor="let rows of codificacionesPorModelo; index as i">
                <div class="vinsRowWrapper" style="height: 40px;">
                  <div class="inputNumeroVINContainer" style="align-items: center;">
                    <div class="inputNumeroVIN" *ngFor="let item of codigoVin">
                      <span class="codificacionVista" *ngIf="!habilitarModificarModelos">
                        {{rows.codificacion[item-1] === ' ' ? '*' : rows.codificacion[item-1]}}
                      </span>
                      <input *ngIf="habilitarModificarModelos" matInput type="text" maxlength="1"
                        [disabled]="disabledInputs(item, rows)" (ngModelChange)="modifyDigito(item, i, $event)"
                        [ngModel]="codificacionesPorModelo[i].codificacion[item-1].trim()" [ngClass]="styleInputsModificar(item)"
                        autocomplete="off">
                    </div>
                  </div>
                  <div (click)="openPopUpConfirmacion('codificacion', rows)" class="trashContainer"
                    *ngIf="habilitarModificarModelos && codificacionesPorModelo.length > 1"
                    style="align-items: center;">
                    <i class="fa fa-trash" style="font-size: 20px; cursor: pointer; color: #007749;"></i>
                  </div>
                </div>
              </div>
              <!-- Codificaciones Nuevas -->
              <div class="vinsRow" *ngFor="let rows of codificacionesPorModelosNuevas; index as i">
                <div *ngIf="habilitarModificarModelos" class="vinsRowWrapper" style="height: 40px;">
                  <div class="inputNumeroVINContainer" style="align-items: center;">
                    <div class="inputNumeroVIN" *ngFor="let item of codigoVin">
                      <input matInput type="text" maxlength="1" [disabled]="disabledInputs(item, rows)"
                        (ngModelChange)="saveDigitoModificacion(item, i, $event)"
                        [ngModel]="codificacionesPorModelosNuevas[i][item-1].trim()" [ngStyle]="styleInputs(item)"
                        autocomplete="off">
                    </div>
                  </div>
                  <div (click)="deleteCodificacionNuevaModificacion(i)" class="trashContainer"
                    style="align-items: center;">
                    <i class="fa fa-trash" style="font-size: 20px; cursor: pointer; color: #007749;"></i>
                  </div>
                </div>
              </div>
              <div class="agregarVinBTNContainer">
                <button nbButton size="tiny" status="primary" class="buttontz" *ngIf="habilitarModificarModelos"
                  (click)="agregarVinModificacion()">
                  <i class="fa fa-plus" style="font-size: 10px; cursor: pointer; color: white;"></i>
                </button>
              </div>

            </div>
            <!--  -->
          </div>

        </div>

      </div>

      <div class="bodyModificacionBottom">
        <app-spinner class="float-left" *ngIf="showSpinnerModificarVin"></app-spinner>
        <div class="modeloModificacionBottomBTNS" *ngIf="modeloSeleccionado && !showSpinnerModificarVin">
          <button nbButton size="tiny" status="primary" class="buttontz"
            (click)="modificarModelos2()">Modificar</button>
          <button nbButton size="tiny" status="primary" class="buttontz"
            (click)="openPopUpConfirmacion('modelo')">Eliminar
            Modelo</button>
        </div>
        <button nbButton size="tiny" status="primary" class="buttontz" [disabled]="guardarModificarDisabled"
          *ngIf="modeloSeleccionado && !showSpinnerModificarVin" (click)="guardarCambios()">Guardar Cambios</button>
      </div>

    </div>
  </nb-tab>
</nb-tabset>